import { Component, OnInit, OnDestroy } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CustomValidators} from 'ng2-validation';
import {Subscription} from 'rxjs/Subscription';
import {FooterNavbarService} from 'services/connectors/footer-navbar.service';
import {EmissionService} from 'services/emission.service';
import {Constants} from 'config/constants';
import {SpinnerService} from 'services/spinner.service';

@Component({
    selector: 'tpc-commute',
    templateUrl: './commute.component.html',
    styleUrls: ['./commute.component.css']
})
export class CommuteComponent implements OnInit, OnDestroy {
    private nextSub: Subscription;
    private isFormSubmited = false;
    private countDefaultValue = 0;

    private _form: FormGroup;

    constructor(private emissionService: EmissionService,
                private footerService: FooterNavbarService,
                private fb: FormBuilder,
                private spinner: SpinnerService
    ) {
        this.nextSub = footerService.next$.subscribe(() => {
            this.isFormSubmited = true;
            if (this.form.status === 'VALID') {
                this.next();
            }
        });
        this.createForm();
    }

    ngOnInit() {
    }

    get form(): FormGroup {
        return this._form;
    }

    private createForm() {
        this._form = this.fb.group({
            carPeople: [this.countDefaultValue, [
                Validators.required,
                CustomValidators.min(0),
                CustomValidators.max(999999),
                CustomValidators.digits]],
            carMile: [this.countDefaultValue, [
                Validators.required,
                CustomValidators.min(0),
                CustomValidators.max(999),
                CustomValidators.digits]],
            trainPeople: [this.countDefaultValue, [
                Validators.required,
                CustomValidators.min(0),
                CustomValidators.max(999999),
                CustomValidators.digits]],
            trainMile: [this.countDefaultValue, [
                Validators.required,
                CustomValidators.min(0),
                CustomValidators.max(999),
                CustomValidators.digits]],
            busPeople: [this.countDefaultValue, [
                Validators.required,
                CustomValidators.min(0),
                CustomValidators.max(999999),
                CustomValidators.digits]],
            busMile: [this.countDefaultValue, [
                Validators.required,
                CustomValidators.min(0),
                CustomValidators.max(999),
                CustomValidators.digits]],
            taxiPeople: [this.countDefaultValue, [
                Validators.required,
                CustomValidators.min(0),
                CustomValidators.max(999999),
                CustomValidators.digits]],
            taxiMile: [this.countDefaultValue, [
                Validators.required,
                CustomValidators.min(0),
                CustomValidators.max(999),
                CustomValidators.digits]],
            ferryPeople: [this.countDefaultValue, [
                Validators.required,
                CustomValidators.min(0),
                CustomValidators.max(999999),
                CustomValidators.digits]],
            ferryMile: [this.countDefaultValue, [
                Validators.required,
                CustomValidators.min(0),
                CustomValidators.max(999),
                CustomValidators.digits]],
        });
    }

    checkError(param) {
        return this.form.get(param).status === 'INVALID' && (this.isFormSubmited || this.form.get(param).touched);
    }

    next() {
        let calculatorName = Constants.calculators.business;
        let categoryName = 'commute';
        let params = {
            carPeople: this.getFV('carPeople'),
            carMile: this.getFV('carMile'),
            trainPeople: this.getFV('trainPeople'),
            trainMile: this.getFV('trainMile'),
            busPeople: this.getFV('busPeople'),
            busMile: this.getFV('busMile'),
            taxiPeople: this.getFV('taxiPeople'),
            taxiMile: this.getFV('taxiMile'),
            ferryPeople: this.getFV('ferryPeople'),
            ferryMile: this.getFV('ferryMile')
        };

        if ((!!+params.carPeople && !!+params.carMile) || (!!+params.trainPeople && !!+params.trainMile) ||
            (!!+params.busPeople && !!+params.busMile) || (!!+params.taxiPeople && !!+params.taxiMile) ||
            (!!+params.ferryPeople && !!+params.ferryMile)) {
            this.spinner.show();
            this.emissionService.getEmissionValue(params, calculatorName, categoryName).subscribe(
                response => {
                    let input = response.body[0].input[0];
                    this.emissionService.setEmission({
                        category: Constants.categories.business.commute,
                        emission: {
                            emission: input.emmission,
                            emissionTrees: input.emissionTrees,
                            DollarAmt: input.DollarAmt,
                            DollarAmtMonthly: input.DollarAmtMonthly
                        }
                    });

                    this.footerService.skip();
                    this.spinner.hide();
                }
            );
        } else {
            this.emissionService.setEmission({
                category: Constants.categories.business.commute,
                emission: {
                    emission: 0,
                    emissionTrees: 0,
                    DollarAmt: 0,
                    DollarAmtMonthly: 0
                }
            });

            this.footerService.skip();
        }
    }

    getFV(param) {
        return this.form.get(param).value;
    }

    ngOnDestroy () {
        if (this.nextSub) {
            this.nextSub.unsubscribe();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/business-calculator/commute/commute.component.ts